import { render, staticRenderFns } from "./xmgdViewFile.vue?vue&type=template&id=7db31e12&scoped=true"
import script from "./xmgdViewFile.vue?vue&type=script&lang=js"
export * from "./xmgdViewFile.vue?vue&type=script&lang=js"
import style0 from "./xmgdViewFile.vue?vue&type=style&index=0&id=7db31e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db31e12",
  null
  
)

export default component.exports